import { render } from "./PostReactionComponent.vue?vue&type=template&id=466a2e6c&ts=true"
import script from "./PostReactionComponent.vue?vue&type=script&lang=ts"
export * from "./PostReactionComponent.vue?vue&type=script&lang=ts"

import "./PostReactionComponent.vue?vue&type=style&index=0&id=466a2e6c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__